import React,{useEffect,useRef,useState} from 'react';
import {apiUrl,AMBIENTE_DESENVOLVIMENTO} from './apiAmbiente';
import {CHAVE_SESSAO,ehSuperadmin} from './sessaoUsuario';

export default function PublicarVersao() {
  const autorizado=AMBIENTE_DESENVOLVIMENTO&&ehSuperadmin();
  const [versoes,setVersoes]=useState(null),[nova,setNova]=useState(''),[carregando,setCarregando]=useState(false),[publicando,setPublicando]=useState(false),[erro,setErro]=useState(''),[mensagem,setMensagem]=useState('');
  const ocupado=useRef(false),montado=useRef(false);
  async function requisitar(acao,dados={}) {
    const form=new FormData();form.set('token',sessionStorage.getItem(CHAVE_SESSAO)||'');form.set('acao',acao);
    Object.entries(dados).forEach(([k,v])=>form.set(k,v));
    const r=await fetch(apiUrl('DesenvolvimentoVersao.php'),{method:'POST',body:form,cache:'no-store'});
    let x;try{x=await r.json();}catch(_){throw new Error('Resposta invalida da API de versao.');}
    if(!r.ok||!x.ok)throw new Error(x.erro||'Nao foi possivel consultar ou publicar a versao.');
    return x;
  }
  async function consultar() {
    if(!autorizado||ocupado.current)return;ocupado.current=true;setCarregando(true);setErro('');
    try{const x=await requisitar('consultar');if(montado.current)setVersoes(x.versoes);}
    catch(e){if(montado.current){setErro(e.message);setVersoes(null);}}
    finally{ocupado.current=false;if(montado.current)setCarregando(false);}
  }
  useEffect(()=>{montado.current=true;if(autorizado)consultar();return()=>{montado.current=false;};},[autorizado]); // eslint-disable-line react-hooks/exhaustive-deps
  async function publicar(e) {
    e.preventDefault();if(!autorizado||ocupado.current||!versoes)return;
    const versao=nova.trim();setErro('');setMensagem('');
    if(!/^[0-9]{1,6}(?:\.[0-9]{1,6}){1,5}$/.test(versao)){setErro('Informe uma versao como 26.11.3.10.');return;}
    ocupado.current=true;setPublicando(true);
    try{
      const x=await requisitar('publicar',{versao,base_desenv:versoes.desenvolvimento,base_producao:versoes.producao});
      if(montado.current){setVersoes(x.versoes);setNova('');setMensagem(x.mensagem);}
    }catch(err){if(montado.current){setErro(err.message);setVersoes(null);}}
    finally{ocupado.current=false;if(montado.current)setPublicando(false);}
  }
  if(!autorizado)return null;
  return <div className="card card-info mb-3"><div className="card-header"><h3 className="card-title">Versão publicada</h3></div><div className="card-body">
    {erro&&<div className="alert alert-danger" role="alert">{erro}</div>}{mensagem&&<div className="alert alert-success" role="status">{mensagem}</div>}
    <div className="d-flex flex-wrap align-items-center mb-3" style={{gap:16}}>
      <span>Desenvolvimento (ID 1): <strong>{carregando?'Consultando...':versoes?.desenvolvimento??'—'}</strong></span>
      <span>Produção (ID 1): <strong>{carregando?'Consultando...':versoes?.producao??'—'}</strong></span>
      <button type="button" className="btn btn-outline-info btn-sm" disabled={carregando||publicando} onClick={consultar}>Atualizar versões</button>
    </div>
    <form onSubmit={publicar} className="d-flex flex-wrap align-items-end" style={{gap:12}}>
      <label className="mb-0">Nova versão<input className="form-control" aria-label="Nova versão" placeholder="26.11.3.10" value={nova} onChange={e=>setNova(e.target.value)} required maxLength={41} disabled={carregando||publicando}/></label>
      <button type="submit" className="btn btn-info" disabled={!versoes||!nova.trim()||carregando||publicando}>{publicando?'Publicando...':'Publicar nos dois bancos'}</button>
    </form>
    <small className="text-muted d-block mt-2">Atualiza somente Versao.ver do registro ID 1 no desenvolvimento e na produção. Publique depois de disponibilizar o build correspondente.</small>
  </div></div>;
}
